(function() {
    let tlFreeGiftOfferClone;

    async function addGiftsAndRefreshCartContent(items) {
        if (!items.length) return;
        let sectionsToBundle = ["variant-added"];
        document.documentElement.dispatchEvent(
            new CustomEvent("cart:prepare-bundled-sections", {
                bubbles: true,
                detail: {
                    sections: sectionsToBundle,
                },
            })
        );
        let lastResponse = null;

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const isLastItem = i === items.length - 1;

            const formData = new FormData();
            formData.append("id", item.id);
            formData.append("quantity", item.quantity);
            if (item.properties) {
                Object.entries(item.properties).forEach(([key, value]) => {
                    formData.append(`properties[${key}]`, value);
                });
            }
            if (isLastItem) {
                formData.set("sections", sectionsToBundle.join(","));
                formData.set("sections_url", window.location.pathname);
            }
            const response = await fetch(`${Shopify.routes.root}cart/add.js?app=salepify`, {
                method: "POST",
                body: formData,
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    Accept: "application/json",
                },
            });

            const responseJson = await response.json();

            if (!response.ok) {
                throw new Error(
                    responseJson.description ||
                        responseJson.message ||
                        "Failed to add item."
                );
            }

            lastResponse = responseJson;
        }

        const cart = await fetch(`${Shopify.routes.root}cart.js?app=salepify`).then((r) =>
            r.json()
        );

        cart.sections = lastResponse.sections;
        // updateCartContent(cart)

        return cart;
    }

    function updateCartContent(cart) {
        document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                    baseEvent: "variant:add",
                    cart,
                },
            })
        );

        document.dispatchEvent(
            new CustomEvent("cart:open")
        );
    }

    let timer = null;
    
    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if (val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val;
                val.handleAddGifts = async (items , discountCodes, giftIdToShowNoti) => {
                    try {
                        if(discountCodes.length){
                            if(items.length){
                                const addToCartRes = await addGiftsAndRefreshCartContent(items);
                                if(addToCartRes.items){
                                    const giftIdMapSrc = new Map(addToCartRes.items.map(item => [String(item.id), item.image ? item.image : window.tlFreeGiftOffer.fallBackImg]));
                                    const listImgSrc = giftIdToShowNoti.map(id => giftIdMapSrc.get(id)).filter(src => src);

                                    window.tlFreeGiftOffer.showNotification(listImgSrc);

                                    // if all gifts are zero price, no need to apply discount
                                    const areAllGiftsZeroPrice = addToCartRes.items.every(item => item.price === 0)
                                    if(areAllGiftsZeroPrice) {
                                        return { status: 200 };
                                    }
                                }else {
                                    return addToCartRes;
                                }
                            }

                            return await window.tlFreeGiftOffer.applyDiscounts(discountCodes) 
                                ? { status: 200 }
                                : { status: 400, message: "Unable to apply discount to the cart", discountError: true}
                        }
                    } catch (error) {
                        console.log("Error when handleAddGifts: ", error)
                    }
                    
                    return { status: 400, message: "Something went wrong while adding gifts to the cart." };
                }
                val.checkBOGORule = (rule, parentInCart) => {
                    const {BOGO_PROPERTY} = window.tlFreeGiftOffer.constants;
                    const giftIdMapData = new Map();
                    const giftsOfRule = window.tlFreeGiftOffer.ruleIdMapGifts.get(rule.id) ?? [];
            
                    giftsOfRule.forEach((gift) => {
                        const currentData = giftIdMapData.get(gift.id) ?? [];
                        giftIdMapData.set(gift.id, [...currentData, gift]);
                    })

                    const itemIdMapInfo = new Map();
                    parentInCart.forEach((parent) => {
                        const itemId = parent.id;
                        const currentInfo = itemIdMapInfo.get(itemId) ?? {
                            ...parent,
                            quantity: 0, 
                            giftQty: window.tlFreeGiftOffer.getTotalQuantity(giftIdMapData.get(itemId) ?? [])
                        };
                        itemIdMapInfo.set(itemId, {
                            ...currentInfo,
                            quantity: currentInfo.quantity + parent.quantity
                        });
                    })
        
                    let giftsToAdd = [];
                    let giftsToRemove = {};
                    const eligibleItem = new Map();

                    const configuredQty = rule.gift_qty;
                    const maximumPerOrder = rule.maximum_per_order ?? Infinity;
                    const customerBuyArr = Array.from(itemIdMapInfo.values())
                    customerBuyArr.sort((a, b) => {
                        if (b.giftQty !== a.giftQty) {
                            return b.giftQty - a.giftQty;
                        }
                        return a.price - b.price;
                    })

                    let appliedCount = 0;
                    const remainCustomerBuy = [];
                    const variantIdMapState = new Map(); 
                    const applyConditionMaxValue = rule.apply_condition_max_value ?? Infinity;
                    const productStateArr = window.tlFreeGiftOffer.ruleIdMapState.get(rule.id)?.productStateArr || [];
                    const productStateMap = productStateArr.reduce((state, {itemId, ...rest}) => {
                        state[itemId] = rest;
                        return state;
                    }, {});
                    customerBuyArr.forEach((data) => {
                        const {id: itemId, quantity, giftQty} = data;
                        const {
                            canClaimCount: previousCanClaimCount,
                            actualCanClaimedCount: previousActualCanClaimCount
                        } = productStateMap[itemId] || {};
                        let canClaimCount = quantity > applyConditionMaxValue ? 0 : Math.floor(quantity / rule.apply_condition_value);
                            canClaimCount = Math.min(maximumPerOrder - appliedCount, canClaimCount);

                        let claimedCount = giftQty / configuredQty;
                        let actualCanClaimedCount = quantity / rule.apply_condition_value;

                        if(canClaimCount >= claimedCount && canClaimCount != 0){
                            if (!rule.auto_add_gift) {
                                remainCustomerBuy.push({
                                    id: itemId,
                                    quantity: (canClaimCount - claimedCount) * rule.apply_condition_value,
                                    itemData: data,
                                    canClaimCount, claimedCount
                                })
                                appliedCount += claimedCount
                            } else {                        
                                if (previousCanClaimCount !== undefined) {
                                    if (!(previousActualCanClaimCount >= maximumPerOrder && actualCanClaimedCount != previousActualCanClaimCount && claimedCount == 0)) {
                                        const actualMaxCanClaim = applyConditionMaxValue / rule.apply_condition_value;
                                        if (Math.floor(previousActualCanClaimCount) >= Math.floor(actualCanClaimedCount) && claimedCount <= canClaimCount
                                            && !(previousActualCanClaimCount > actualMaxCanClaim && canClaimCount <= actualMaxCanClaim)
                                        ) {
                                            claimedCount = Math.floor(previousActualCanClaimCount);
                                        }
                                    }
                                } else if (window.tlFreeGiftOffer.is_cart_auto_update && claimedCount < canClaimCount && !window.tlFreeGiftOffer.cartHasChanged) {
                                    claimedCount = canClaimCount;
                                }
            
                                const needToPushItemToRemain = claimedCount < canClaimCount;
                                if(needToPushItemToRemain) {
                                    remainCustomerBuy.push({
                                        id: itemId,
                                        quantity: (canClaimCount - claimedCount) * rule.apply_condition_value,
                                        itemData: data,
                                        canClaimCount, claimedCount
                                    })
                                    appliedCount += claimedCount
                                } else {
                                    appliedCount += Math.ceil(giftQty / configuredQty)
                                }
                            }
                        }else if(canClaimCount < claimedCount){
                            let needToRemoveQty = giftQty - configuredQty * canClaimCount;
                            const giftsInCart = giftIdMapData.get(itemId) ?? [];
                            for (const {key, quantity} of giftsInCart) {
                                if(needToRemoveQty > quantity){
                                    giftsToRemove[key] = 0;
                                    needToRemoveQty -= quantity;
                                }else {
                                    giftsToRemove[key] = quantity - needToRemoveQty;
                                    break;
                                }
                            }
                            appliedCount += claimedCount
                        }

                        variantIdMapState.set(itemId, { claimedCount, canClaimCount, actualCanClaimedCount, quantity: data.quantity})
                    })

                    let actualAppliedCount = appliedCount;
                    for (let i = 0; i < remainCustomerBuy.length; i++) {
                        const {id, quantity, itemData, claimedCount} = remainCustomerBuy[i];
                        if(appliedCount < maximumPerOrder){
                            let claimTimes = quantity / rule.apply_condition_value;
                                claimTimes = Math.min(maximumPerOrder - appliedCount, claimTimes);
                            if(claimTimes > 0){
                                if(rule.auto_add_gift){
                                    giftsToAdd.push({
                                        id, 
                                        quantity: claimTimes * configuredQty,
                                        properties: {
                                            [BOGO_PROPERTY]: rule.id
                                        }
                                    })
                                    actualAppliedCount += claimTimes
                                }else {
                                    eligibleItem.set(id, { claimTimes, itemData })
                                }
                                appliedCount += claimTimes

                                variantIdMapState.set(id, {...variantIdMapState.get(id), claimedCount, canClaimCount: claimedCount + claimTimes})
                            }
                        }else {
                            break;
                        }
                    }

                    window.tlFreeGiftOffer.updateBogoRuleState(rule, variantIdMapState, actualAppliedCount)
                    return { needToAdd: !!giftsToAdd.length, giftsToAdd, giftsToRemove, eligibleItem }
                }
            }
        },
        configurable: true
    });
})();